export default __webpack_public_path__ + "static/media/1 (9).c5748ff7.jpg";